import React from 'react';

// Simple inline SVG icons that rely on currentColor
// so they inherit the sidebar text color.

const baseProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

export const DashboardIcon = () => (
  <svg {...baseProps}>
    <rect x="3" y="3" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="13" y="3" width="8" height="5" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="13" y="10" width="8" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="3" y="13" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const SealsIcon = () => (
  <svg {...baseProps}>
    <rect x="5" y="5" width="14" height="14" rx="3" stroke="currentColor" strokeWidth="2" />
    <path d="M9 11h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M9 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CompaniesIcon = () => (
  <svg {...baseProps}>
    <path d="M4 20V8l6-4 6 4v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 10h4M10 14h4M10 18h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const UsersIcon = () => (
  <svg {...baseProps}>
    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M4 18c0-2.5 2-4.5 5-4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="17" cy="10" r="2.5" stroke="currentColor" strokeWidth="2" />
    <path d="M13.5 18c0-2 1.6-3.6 3.5-3.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const DepotsIcon = () => (
  <svg {...baseProps}>
    <rect x="4" y="10" width="16" height="8" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const BoxAssignmentsIcon = () => (
  <svg {...baseProps}>
    <rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M4 10h16" stroke="currentColor" strokeWidth="2" />
    <path d="M10 14h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ContainerAssignIcon = () => (
  <svg {...baseProps}>
    <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M7 11h4M13 11h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const NotificationsIcon = () => (
  <svg {...baseProps}>
    <path d="M12 4a4 4 0 0 0-4 4v3.5L6 14v1h12v-1l-2-2.5V8a4 4 0 0 0-4-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 18a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ReportsIcon = () => (
  <svg {...baseProps}>
    <path d="M6 18V6l4 3 4-5 4 6v8H6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const AuditLogsIcon = () => (
  <svg {...baseProps}>
    <rect x="5" y="4" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M9 8h6M9 12h4M9 16h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ManagerIcon = () => (
  <svg {...baseProps}>
    <circle cx="12" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M6 18c.5-2.5 2.8-4 6-4s5.5 1.5 6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const SettingsIcon = () => (
  <svg {...baseProps}>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    <path
      d="M5 12a7 7 0 0 1 .2-1.6L6.7 10l-.8-2 1.4-1.4 2 .8.4-1.7H14l.4 1.7 2-.8 1.4 1.4-.8 2 1.5.4A7 7 0 0 1 19 12a7 7 0 0 1-.2 1.6L17.3 14l.8 2-1.4 1.4-2-.8L14.3 18H10l-.4-1.7-2 .8L6.2 16l.8-2-1.5-.4A7 7 0 0 1 5 12z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg {...baseProps}>
    <path d="M10 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 9l3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 12H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const DropdownIcon = () => (
  <svg {...baseProps}>
    <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Generic table/action icons used inside DataTable to avoid
// relying on emoji characters that can render as question marks
// in some environments.

export const TableSortIcon = () => (
  <svg {...baseProps}>
    <path d="M12 5l-3 3h6l-3-3z" fill="currentColor" />
    <path d="M12 19l3-3H9l3 3z" fill="currentColor" />
  </svg>
);

export const TableSortAscIcon = () => (
  <svg {...baseProps}>
    <path d="M12 5l-3 3h6l-3-3z" fill="currentColor" />
  </svg>
);

export const TableSortDescIcon = () => (
  <svg {...baseProps}>
    <path d="M12 19l3-3H9l3 3z" fill="currentColor" />
  </svg>
);

export const TableClearIcon = () => (
  <svg {...baseProps}>
    <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="2" />
    <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const TableEditIcon = () => (
  <svg {...baseProps}>
    <path d="M7 17.5L6 20l2.5-1L17 10.5 14.5 8 7 17.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 7.5L15.5 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const TableResetIcon = () => (
  <svg {...baseProps}>
    <path d="M8 9V5H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 8a7 7 0 1 1 2.1 8.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TableDeleteIcon = () => (
  <svg {...baseProps}>
    <path d="M9 5h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M7 8h10v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 11v5M14 11v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ExportCsvIcon = () => (
  <svg {...baseProps}>
    <rect x="4" y="4" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 8h6M8 11h4M8 14h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M18 9v9l-3-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ExportExcelIcon = () => (
  <svg {...baseProps}>
    <rect x="4" y="4" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
